// exports.api = "http://localhost:8893/";  // Developer PC
// exports.base_url = "http://localhost:8893/";  // Developer PC

// exports.api = "https://thesisapi.martersolutions.com/";  // Marter Server
// exports.base_url = "https://thesisapi.martersolutions.com/";  // Marter Server

// exports.api = "https://uvslibrary.edu.mm:8888/";  // UVS Server
// exports.base_url = "https://uvslibrary.edu.mm/api/";  // UVS Server

// exports.api = "http://202.165.95.36:8888/"; // DAR Server
// exports.base_url = "http://202.165.95.36/"; // DAR Server

// exports.api = "https://anatomyapi.uvslibrary.edu.mm/" // Anatomy
// exports.base_url = "https://anatomy.uvslibrary.edu.mm/";  // Anatomy

// exports.api = "https://geneticsabapi.uvslibrary.edu.mm/" // Geneticsab
// exports.base_url = "https://geneticsab.uvslibrary.edu.mm/";  // Geneticsab

// exports.api = "https://pathomicroapi.uvslibrary.edu.mm/" // pathomicro
// exports.base_url = "https://pathomicro.uvslibrary.edu.mm/";  // pathomicro

// exports.api = "https://surtherioapi.uvslibrary.edu.mm/" // surtherio
// exports.base_url = "https://surtherio.uvslibrary.edu.mm/";  // surtherio

// exports.api = "https://animalnutritionapi.uvslibrary.edu.mm/" // Animalnutrition
// exports.base_url = "https://animalnutrition.uvslibrary.edu.mm/";  // Animalnutrition

// exports.api = "https://pharmparaapi.uvslibrary.edu.mm/" // pharmpara
// exports.base_url = "https://pharmpara.uvslibrary.edu.mm/";  // pharmpara

// exports.api = "https://vthapi.uvslibrary.edu.mm/" // vth
// exports.base_url = "https://vth.uvslibrary.edu.mm/";  // vth

// exports.api = "https://physiobiochemapi.uvslibrary.edu.mm/" // physiobiochem
// exports.base_url = "https://physiobiochem.uvslibrary.edu.mm/";  // physiobiochem

// exports.api = "https://vphepiapi.uvslibrary.edu.mm/" // vphepi
// exports.base_url = "https://vphepi.uvslibrary.edu.mm/";  // vphepi

// exports.api = "https://vetmedicineapi.uvslibrary.edu.mm/" // vetmedicine
// exports.base_url = "https://vetmedicine.uvslibrary.edu.mm/";  // vetmedicine

// exports.api = "https://aquawildlifeapi.uvslibrary.edu.mm/" // aquawildlife
// exports.base_url = "https://aquawildlife.uvslibrary.edu.mm/";  // aquawildlife

exports.api = "https://ldfapi.uvslibrary.edu.mm/" // aquawildlife
exports.base_url = "https://ldf.uvslibrary.edu.mm/";  // aquawildlife

// exports.user_info = JSON.parse(localStorage.getItem('user_info'));

var moment = require("moment-timezone");
// to get date with format('your format')

var c_date = moment()
  .tz("Asia/Yangon")
  .format();

var date = new Date(c_date),
  y = date.getFullYear(),
  m = date.getMonth(),
  d = date.getDate();

var backDate = new Date(y, m, d - 5);
var endDate = new Date(y, m + 1, 0);

exports.getCurrentDate = () => {
  var m = new Date();
  var dateString =
  m.getUTCFullYear() + "-" +
  ("0" + (m.getUTCMonth()+1)).slice(-2) + "-" +
  ("0" + m.getUTCDate()).slice(-2) + " " +
  ("0" + m.getUTCHours()).slice(-2) + ":" +
  ("0" + m.getUTCMinutes()).slice(-2) + ":" +
  ("0" + m.getUTCSeconds()).slice(-2);
  return dateString;
}

exports.backDate = backDate;

exports.endDate = endDate;
